<template lang="pug">
div
  el-row.dashedBox
      el-col(:span="2").icon-dashedBox
        img(src="@/assets/icons/IconesObservacoes/16.png")
      el-col(:span="22").text-dashedBox
        ul
          li Declaração de Posse
      el-col(:span="22").button-baixar
        el-button.botao(
          type="success",
          @click="baixarModelo('declaracao_posse')",
          :loading="loading",
          icon="fas fa-cloud-download-alt"
        )
          span
            b.text-botao Baixar
  el-row.dashedBox
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/16.png")
    el-col(:span="22").text-dashedBox
      ul
        li Declaração de Residência
    el-col(:span="22").button-baixar
        el-button.botao(
          type="success",
          @click="baixarModelo('declaracao_residencia')",
          :loading="loading",
          icon="fas fa-cloud-download-alt"
        )
          span
            b.text-botao Baixar
  el-row.dashedBox
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/16.png")
    el-col(:span="22").text-dashedBox
      ul
        li Declaração Negativa de Propriedade Imóvel Rural
    el-col(:span="22").button-baixar
        el-button.botao(
          type="success",
          @click="baixarModelo('declaracao_negativa')",
          :loading="loading",
          icon="fas fa-cloud-download-alt"
        )
          span
            b.text-botao Baixar

</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      downloadModelo: 'downloadPortal/downloadModeloDeclaracao'
    }),

    async baixarModelo (tipoModelo) {
      this.loading = true
      this.downloadModelo('MODELO_' + tipoModelo.toUpperCase())
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/element-variables.scss';

.dashedBox {
  border: 1.8px dashed $--color-primary;
  display: flex;
  margin: 20px 0;
  border-radius: 10px;
}

.icon-dashedBox {
  background-color: $--color-primary;
  color: white;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px 0 0 8px;
}

.icon-dashedBox img {
  width: 3.8em;
}

.text-dashedBox {
  padding: 20px 20px;
}

.text-dashedBox li,
i {
  font-size: 1rem;
  line-height: 2rem;
}

.red {
  color: red;
}

.orange {
  color: orange;
}

.url {
  color: #009f61;
}

.botao {
  opacity: 0;
  transition: opacity 0.2s ease-in;
  text-align: center;
  justify-self: right;
}

.text-botao {
  margin-left: 10px;
}

.button-baixar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 30px;
}

.dashedBox:hover {
  .botao {
    opacity: 100;
    display: block;
  }
}

@media screen and (max-width: 1024px) {
  .dashedBox {
    display: flex;
    flex-direction: column;
  }

  .icon-dashedBox {
    border-radius: 8px 8px 0 0;
  }

  .icon-dashedBox {
    width: 100%;
  }

  .iconExclamation {
    background-color: none;
    border-radius: 0 0 100% 100%;
    border-left: 3px solid white;
  }

  .button-baixar{
    padding-bottom: 20px;
    padding-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/informacao/ModelosDocumentos.vue